import { useState } from 'react'
import Navigation from './components/Navigation'
import Hero from './components/Hero'
import EventDetails from './components/EventDetails'
// import RSVP from './components/RSVP'
import PhotoGallery from './components/PhotoGallery'
import TravelInfo from './components/TravelInfo'
import HoneymoonFund from './components/HoneymoonFund'
import Footer from './components/Footer'

function App() {
  const [activeSection, setActiveSection] = useState('home')

  return (
    <div className="min-h-screen bg-cream">
      <Navigation activeSection={activeSection} setActiveSection={setActiveSection} />
      
      <main>
        <section id="home">
          <Hero />
        </section>
        
        <section id="details">
          <EventDetails />
        </section>
        
        {/* <section id="rsvp">
          <RSVP />
        </section> */}
        
        <section id="photos">
          <PhotoGallery />
        </section>
        
        <section id="honeymoon">
          <HoneymoonFund />
        </section>
        
        <section id="travel">
          <TravelInfo />
        </section>
      </main>
      
      <Footer />
    </div>
  )
}

export default App
